module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card message",
    attrs: {
      "height": "335",
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" " + _vm._s(_vm.$t('MESSAGES')))]), _vm._v(" "), (_vm.isAllowed('send', 'report/message')) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.$t('WRITEAMESSAGE'),
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.messageBox = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment fa-2x"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.message_loading),
      expression: "message_loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listMessages,
      "row-class-name": "pointer-hover",
      "height": 340,
      "stripe": ""
    },
    on: {
      "current-change": _vm.selectedConversation
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "media"
        }, [_c('div', {
          staticClass: "media-left"
        }, [_c('img', {
          staticClass: "img-circle",
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "src": _vm.getAsset(scope.row.monitor.ImagePath, 'supervisor')
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "media-body"
        }, [_vm._v("\n                    " + _vm._s(_vm._FullName({
          NameEN: scope.row.monitor.FullName_EN,
          NameAR: scope.row.monitor.FullName_AR
        })) + "\n                    "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s((scope.row.time_ago.split(' ').length === 1) ? _vm.$t(scope.row.time_ago.split(' ')[0]) : _vm.$t(scope.row.time_ago.split(' ')[1], {
          var: scope.row.time_ago.split(' ')[0]
        })))]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.readMore(scope.row.Text)) + "\n                ")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "bottom clearfix"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isAllowed('index', 'report/message')
    },
    on: {
      "click": function($event) {
        _vm.viewMore('message')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('VIEWMORE')))])], 1)])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card violation",
    attrs: {
      "height": "335",
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_c('i', {
    class: 'fa ' + (_vm.wiot_box == 1 ? 'fa-tachometer' : 'fa-user-times')
  }), _vm._v(" " + _vm._s(_vm.$t(_vm.wiot_box != 1 ? 'SCHOOLANDBUSABSENCES' : 'BUSVIOLATIONSANDALARMS')))]), _vm._v(" "), (_vm.wiot_box != 1) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.$t('SWITCHTOABSENCES', {
        var: _vm.$t(_vm.absenceFrom == 'bus' ? 'SCHOOL' : 'BUS')
      }),
      "placement": "top"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.switchTo()
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.absenceFrom !== 'bus' ? 'fa-university' : 'fa-bus']
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.absenceFrom !== 'bus' ? _vm.$t('SCHOOL') : _vm.$t('BUS'))
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.wiot_box != 1) ? _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.absence_loading),
      expression: "absence_loading"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listAbsences,
      "row-class-name": "pointer-hover",
      "highlight-current-row": "",
      "height": 340,
      "stripe": ""
    },
    on: {
      "row-click": _vm.showAbsence
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "min-width": "175",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          staticStyle: {
            "width": "49px",
            "float": "left"
          },
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath, 'student'),
            "alt": ""
          }
        }), _vm._v("\n          " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        })) + "\n\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('DATE'),
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.date_format(scope.row.AbsentDate))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t(_vm.absenceFrom == 'bus' ? 'PICK-UP/DROP-OFF' : 'REASON'),
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s((_vm.absenceFrom == 'bus' ? _vm.$t(scope.row.Direction.title) : _vm.$t(scope.row.Reason.toUpperCase()))) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('REPORTEDBY'),
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t(scope.row.ReportedBy)))])]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.wiot_box == 1) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.violation_loading),
      expression: "violation_loading"
    }],
    attrs: {
      "data": _vm.violations,
      "element-loading-text": _vm.$t('LOADING'),
      "height": 340,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "bus_plate",
      "label": _vm.$t('BUS'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.busNumber)), _c('br'), _c('small', [_vm._v(_vm._s(scope.row.datetime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('VIOLATION'),
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm.$t(scope.row.Label)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": scope.row.IsSticky ? _vm.$t('UNSTICK') : _vm.$t('STICK'),
            "placement": "top"
          }
        }, [(_vm.isAllowed('flag', 'report/violation')) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.flagItem(scope.row, scope.$index, 'violation')
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.IsSticky ? 'fa-flag text-danger' : 'fa-flag-o']
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": scope.row.IsHidden ? _vm.$t('SHOW') : _vm.$t('HIDE'),
            "placement": "top"
          }
        }, [(_vm.isAllowed('flag', 'report/violation')) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.hideItem(scope.row, scope.$index, 'violation')
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.IsHidden ? 'fa-eye-slash' : 'fa-eye']
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "bottom clearfix"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isAllowed('index', _vm.wiot_box == 1 ? 'report/violation' : 'attendance/absence')
    },
    on: {
      "click": function($event) {
        _vm.viewMore(_vm.wiot_box == 1 ? 'violation' : 'absence')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('VIEWMORE')))])], 1)])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card incident",
    attrs: {
      "height": 335,
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.$t('INCIDENTS')))])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.incident_loading),
      expression: "incident_loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.incidents,
      "height": 340,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "150",
      "label": _vm.$t('BUSSUPERVISOR')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                     " + _vm._s(_vm._FullName({
          NameEN: scope.row.monitor.FullName_EN,
          NameAR: scope.row.monitor.FullName_AR
        }))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.incident_date(scope.row.Timestamp)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STUDENTS'),
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                        " + _vm._s(scope.row.student_id.length) + "\n                                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STATUS'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.status[scope.row.statusColor]
          }
        }, [_vm._v("\n                                            " + _vm._s(_vm.reportStatus[scope.row.statusColor]) + "\n                                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('VIEWINCIDENTDETAILS'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "small"
          },
          on: {
            "click": function($event) {
              _vm.showIncident(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-info-circle"
        }), _vm._v(" " + _vm._s(_vm.$t('DETAILS')))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": scope.row.IsSticky ? _vm.$t('UNSTICK') : _vm.$t('STICK'),
            "placement": "top"
          }
        }, [(_vm.isAllowed('flag', 'report/incident')) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.flagItem(scope.row, scope.$index, 'incident')
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.IsSticky ? 'fa-flag text-danger' : 'fa-flag-o']
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "bottom clearfix"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isAllowed('index', 'report/incident')
    },
    on: {
      "click": function($event) {
        _vm.viewMore('incident')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('VIEWMORE')))])], 1)])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card transport",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bus"
  }), _vm._v(" " + _vm._s(_vm.$t('BUSTRIPS')))]), _vm._v(" "), (_vm.delayed_trips != 0) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.$t('SWITCHTO', {
        var: _vm.$t(!_vm.started_mode ? 'ACTIVE' : 'DELAYED')
      }),
      "placement": "top"
    }
  }, [(_vm.delayed_trips != 0) ? _c('el-badge', {
    staticClass: "trip-badge",
    attrs: {
      "value": _vm.delayedCount,
      "hidden": !_vm.started_mode
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.started_mode = !_vm.started_mode
      }
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t(!_vm.started_mode ? 'ACTIVE' : 'DELAYED'))
    }
  })])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.trip_loading),
      expression: "trip_loading"
    }],
    staticStyle: {
      "height": "340px"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('VuePerfectScrollbar', {
    style: ({
      height: '340px'
    })
  }, [_vm._l((_vm.sortedTrips), function(trip, index) {
    return (_vm.sortedTrips.length > 0) ? _c('el-button', {
      key: index,
      staticClass: "trip-box",
      attrs: {
        "disabled": trip.disabledTrip,
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.goTo(trip.TripID)
        }
      }
    }, [_c('el-row', {
      staticStyle: {
        "padding": "0 10px"
      }
    }, [_c('el-col', {
      staticClass: "busTag",
      attrs: {
        "span": _vm.showActivity(trip.activity) ? 2 : 4
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-bus"
    }), _vm._v(" " + _vm._s(trip.busNumber) + " ")])], 1), _vm._v(" "), (_vm.showActivity(trip.activity)) ? _c('el-col', {
      staticClass: "activity",
      attrs: {
        "span": 5,
        "align": _vm.alignDirection('right')
      },
      nativeOn: {
        "mouseover": function($event) {
          trip.disabledTrip = true
        },
        "mouseleave": function($event) {
          trip.disabledTrip = false
        }
      }
    }, [_c('el-popover', {
      attrs: {
        "trigger": "hover",
        "disabled": trip.activity.total_violations == 0,
        "title": _vm.$t('TRIPVIOLATIONS'),
        "placement": "right",
        "width": "450"
      }
    }, [_c('el-badge', {
      attrs: {
        "slot": "reference",
        "value": trip.activity.total_violations,
        "max": 6
      },
      slot: "reference"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "fa fa-tachometer"
    })])], 1), _vm._v(" "), _c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.arrayOfAlerts(trip.activity.violations),
        "empty-text": _vm.$t('NOVIOLATIONS'),
        "stripe": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "label": "Type",
        "min-width": "115"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm.$t(scope.row.incident_type)))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "min-width": "185",
        "label": "Date"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-icon', {
            attrs: {
              "name": "time"
            }
          }), _vm._v(" "), _c('span', {
            staticStyle: {
              "margin-left": "5px"
            }
          }, [_vm._v(_vm._s(_vm.activity_time(scope.row.Timestamp)))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "145",
        "show-overflow-tooltip": "",
        "property": "Text",
        "label": "Message"
      }
    })], 1)], 1), _vm._v(" "), _c('el-popover', {
      attrs: {
        "popper-class": "trip",
        "trigger": "hover",
        "disabled": trip.activity.total_alerts == 0,
        "title": _vm.$t('TRIPALERTS'),
        "placement": "right-start",
        "width": "620"
      }
    }, [_c('el-badge', {
      attrs: {
        "slot": "reference",
        "value": trip.activity.total_alerts,
        "max": 6
      },
      slot: "reference"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "fa fa-bell",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.arrayOfAlerts(trip.activity.alerts),
        "default-sort": {
          prop: 'Sent',
          order: 'descending'
        },
        "empty-text": _vm.$t('NOALERTS'),
        "stripe": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "85",
        "label": _vm.$t('TYPE')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm.$t(scope.row.Event)))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "130",
        "label": _vm.$t('OCCURED')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm.$t(scope.row.EventType)))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "195",
        "property": "Sent",
        "label": _vm.$t('DATE')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-icon', {
            attrs: {
              "name": "time"
            }
          }), _vm._v(" "), _c('span', {
            staticStyle: {
              "margin-left": "5px"
            }
          }, [_vm._v(_vm._s(_vm.activity_time(scope.row.Sent)))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "show-overflow-tooltip": "",
        "label": _vm.$t('MESSAGE')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.Text ? scope.row.Text : '-'))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.EntityID != null || scope.row.Event == 'INCIDENT') ? _c('el-button', {
            attrs: {
              "size": "mini",
              "loading": scope.row.EventID === _vm.sendingEvent
            },
            on: {
              "click": function($event) {
                _vm.activityInfo(scope.row, scope.$index)
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('MOREINFO')))]) : _vm._e()]
        }
      }])
    })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": _vm.showActivity(trip.activity) ? 11 : 14,
        "align": "center"
      }
    }, [_c('i', {
      staticClass: "fa fa-road fa-2x"
    }), _vm._v(" " + _vm._s(trip.TourName))]), _vm._v(" "), _c('el-col', {
      staticClass: "boardingTag",
      attrs: {
        "span": 6
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-user-circle"
    }), _vm._v(" "), _c('b', {
      domProps: {
        "textContent": _vm._s(trip.Boarding)
      }
    })]), _vm._v(" "), (trip.IsClosed != 1) ? _c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    }), _vm._v(" " + _vm._s(_vm.nextStop(trip)))]) : _vm._e(), _vm._v(" "), (trip.IsClosed == 1) ? _c('el-tag', {
      attrs: {
        "type": "success"
      }
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" "), _c('b', {
      domProps: {
        "textContent": _vm._s(trip.CompletedIn)
      }
    }), _vm._v(" " + _vm._s(_vm.$t('MINUTES')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 2,
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "disabled": trip.Db_Date == null,
        "effect": "light",
        "content": _vm.$t('STARTEDAT') + ' ' + _vm.tripTime(trip.timestamp),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: [trip.Direction == 1 ? 'fa-home' : 'fa-university']
    })])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20,
        "align": "center"
      }
    }, [_c('div', {
      staticClass: "el-progress el-progress--line el-progress--without-text",
      class: [trip.Db_Date === null ? 'is-exception' : 'is-success']
    }, [_c('div', {
      staticClass: "el-progress-bar"
    }, [_c('div', {
      staticClass: "el-progress-bar__outer",
      staticStyle: {
        "height": "18px"
      }
    }, [(trip.IsClosed != 1) ? _c('div', {
      staticClass: "el-progress-bar__inner",
      style: ({
        width: _vm.progressWidth(trip) + '%'
      })
    }) : _vm._e(), _vm._v(" "), (trip.IsClosed != 1) ? _c('i', {
      staticClass: "fa fa-circle",
      style: (_vm.ballDirection(trip))
    }) : _vm._e(), _vm._v(" "), (trip.IsClosed == 1) ? _c('div', {
      staticStyle: {
        "padding-top": "2px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('TRIPCLOSED')))]) : _vm._e(), _vm._v(" "), (trip.Db_Date === null) ? _c('div', {
      staticStyle: {
        "padding-top": "2px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('EXPECTEDTOSTART')) + " "), _c('span', {
      staticClass: "delayed pull-right"
    }, [_vm._v(_vm._s(_vm.$t('DELAYEDBY') + ' ' + _vm.delayed_time(trip)))])]) : _vm._e()])])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2,
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "disabled": trip.Db_Date == null,
        "effect": "light",
        "content": trip.IsClosed == 1 ? (_vm.$t('CLOSEDAT') + ' ' + _vm.tripTime(trip.UpdatedAt)) : _vm.$t('NOTCLOSINGYET'),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: [trip.Direction != 1 ? 'fa-home' : 'fa-university']
    })])], 1)], 1), _vm._v(" "), (_vm.showCost(trip)) ? _c('el-row', {
      staticStyle: {
        "padding": "0 10px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('FUELCOST') + ' ' + trip.TravelCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.TravelCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('IDLECOST') + ' ' + trip.IdleCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.IdleCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('TOTALCOST') + ' ' + trip.TotalCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.TotalCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), (_vm.sortedTrips.length == 0) ? _c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v(_vm._s(_vm.$t('NODATA')))])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "border-top": "1px solid #ddd"
    }
  }, [_c('div', {
    staticClass: "bottom clearfix"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.viewMore('trip')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('VIEWMORE')))])], 1)])])], 1)], 1), _vm._v(" "), _c('el-absence-dialog', {
    attrs: {
      "data": _vm.absence,
      "selected-student": _vm.absence_student,
      "visible": _vm.absenceBox
    },
    on: {
      "update": _vm.updateAbsence,
      "update:visible": function($event) {
        _vm.absenceBox = $event
      }
    }
  }), _vm._v(" "), _c('el-message-dialog', {
    attrs: {
      "visible": _vm.messageBox
    },
    on: {
      "update:visible": function($event) {
        _vm.messageBox = $event
      }
    }
  }), _vm._v(" "), _c('el-incident-dialog', {
    attrs: {
      "alert": _vm.notifyAlert,
      "incident": _vm.incident,
      "visible": _vm.incidentBox
    },
    on: {
      "deleteIncident": _vm.deleteIncident,
      "update:visible": function($event) {
        _vm.incidentBox = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3be7378a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 593
// module chunks = 1